// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatInput.css - Styling for chat input aligned with content */

/* Style enhancements for the prompt form */
.prompt-form {
  background-color: white;
  width: 100%;
  margin: 0;
  padding: 8px 0;
}

/* Dark mode adjustments */
.dark .prompt-form {
  background-color: #343541;
}

/* Container styles to ensure proper centering */
.prompt-container {
  max-width: 900px !important;
  width: 100% !important;
  margin: 0 auto !important;
  padding: 0 16px !important;
  transition: all 0.3s ease;
}

/* Mobile adjustments */
@media (max-width: 767px) {
  .prompt-container {
    padding: 0 8px !important;
  }

  .prompt-form {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 30 !important;
    padding: 8px 0 !important;
  }
}

/* Android system navigation bar adjustments */
.android-device .prompt-form {
  /* Safe area bottom padding for devices with notches */
  padding-bottom: env(safe-area-inset-bottom, 0) !important;
  padding-bottom: constant(safe-area-inset-bottom, 0) !important;
}

.android-nav-present .prompt-form {
  /* Add extra padding for Android system navigation bar (typical height 48dp) */
  padding-bottom: calc(env(safe-area-inset-bottom, 16px) + 32px) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ChatInput.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;EAC3B;AACF;;AAEA,8CAA8C;AAC9C;EACE,sDAAsD;EACtD,yDAAyD;EACzD,8DAA8D;AAChE;;AAEA;EACE,8EAA8E;EAC9E,yEAAyE;AAC3E","sourcesContent":["/* ChatInput.css - Styling for chat input aligned with content */\n\n/* Style enhancements for the prompt form */\n.prompt-form {\n  background-color: white;\n  width: 100%;\n  margin: 0;\n  padding: 8px 0;\n}\n\n/* Dark mode adjustments */\n.dark .prompt-form {\n  background-color: #343541;\n}\n\n/* Container styles to ensure proper centering */\n.prompt-container {\n  max-width: 900px !important;\n  width: 100% !important;\n  margin: 0 auto !important;\n  padding: 0 16px !important;\n  transition: all 0.3s ease;\n}\n\n/* Mobile adjustments */\n@media (max-width: 767px) {\n  .prompt-container {\n    padding: 0 8px !important;\n  }\n\n  .prompt-form {\n    position: fixed !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    z-index: 30 !important;\n    padding: 8px 0 !important;\n  }\n}\n\n/* Android system navigation bar adjustments */\n.android-device .prompt-form {\n  /* Safe area bottom padding for devices with notches */\n  padding-bottom: env(safe-area-inset-bottom, 0) !important;\n  padding-bottom: constant(safe-area-inset-bottom, 0) !important;\n}\n\n.android-nav-present .prompt-form {\n  /* Add extra padding for Android system navigation bar (typical height 48dp) */\n  padding-bottom: calc(env(safe-area-inset-bottom, 16px) + 32px) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
